export const empresas = {
  taodograo: {
    id: "taodograo",
    nome: "Tao do Grão",
    tipo: "Restaurante",
    descricao: "Restaurante e café com pratos caseiros e noites temáticas.",
    horarioFuncionamento: {
      segunda: { inicio: "11h30", fim: "14h30" },
      terca: { inicio: "11h30", fim: "14h30" },
      quarta: { inicio: "11h30", fim: "14h30" },
      quinta: { inicio: "11h30", fim: "14h30" },
      sexta: { inicio: "11h30", fim: "22h" },
      sabado: { inicio: "11h30", fim: "15h" },
      domingo: { inicio: "11h30", fim: "15h" }
    },
    servicos: ["Buffet completo", "Comida caseira", "Opções vegetarianas e veganas", "Delivery", "Reservas", "Happy hour", "Dias temáticos"],
    endereco: "Estrada do Altiplano Leste - Estação Marina da Rocha, Loja 08 - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "https://www.instagram.com/taodograo/"
    },
    imagem: "/images/lojistas/tao.png",
    logo: "/images/lojistas/taodograo.png",
    avaliacao: 4.7,
    numeroAvaliacoes: 76,
    telefone: "(61) 98282-6349",
    whatsapp: "61982826349",
    andar: "Térreo",
    preco: "R$ 40 - R$ 60",
    aberto: true,
    promocao: {
      titulo: "Dias Temáticos",
      descricao: "Noites e dias especiais temáticos com atmosfera única"
    },
    comodidades: ["Wi-Fi Gratuito", "Ar Condicionado", "Acessível", "Aceita Cartão", "Delivery", "Reservas", "Happy hour", "Opções veganas"],
    especialidades: ["Estrogonofe", "Feijoada Tradicional", "Comida Caseira", "Opções Vegetarianas e Veganas", "Buffet Completo", "Dias Temáticos", "File Mignon", "Frango Oriental"],
    tags: ["Comida Caseira", "Restaurante", "Café", "Vegetariano", "Vegano", "Buffet"]
  },

  sosauide: {
    id: "sosauide",
    nome: "Só Saúde Açaí",
    tipo: "Sorveteria e açaí",
    descricao: "Açaí, sorvetes e opções saudáveis para o dia a dia.",
    horarioFuncionamento: {
      segunda: { inicio: "13h", fim: "20h" },
      terca: { inicio: "13h", fim: "20h" },
      quarta: { inicio: "13h", fim: "20h" },
      quinta: { inicio: "13h", fim: "20h" },
      sexta: { inicio: "13h", fim: "20h" },
      sabado: { inicio: "13h", fim: "20h" },
      domingo: { inicio: "13h", fim: "20h" }
    },
    servicos: ["Açaí", "Sorvetes", "Picolés naturais", "Delivery"],
    endereco: "Estrada do Altiplano Leste - Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "https://www.instagram.com/so_saude_acai/"
    },
    imagem: "/images/lojistas/sorvete.png",
    logo: "/images/lojistas/sosauide.png",
    avaliacao: 4.7,
    numeroAvaliacoes: 167,
    telefone: "(61) 99179-2363",
    whatsapp: "61991792363",
    andar: "Térreo",
    preco: "R$ 8 - R$ 25",
    aberto: true,
    promocao: {
      titulo: "Açaí do Dia",
      descricao: "Açaí especial com frutas por R$ 12,90"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Delivery"],
    especialidades: ["Açaí Natural", "Sorvetes", "Picolés Artesanais", "Opções Saudáveis", "Frutas Frescas", "Qualidade Premium"],
    tags: ["Açaí", "Saudável", "Natural", "Sorveteria"]
  },

  agropecuaria: {
    id: "agropecuaria",
    nome: "Agropecuária Flor do Cerrado",
    tipo: "Agropecuária e Pet Shop",
    descricao: "Pet shop e agropecuária com rações, produtos veterinários e banho & tosa.",
    horarioFuncionamento: {
      segunda: { inicio: "8h", fim: "19h" },
      terca: { inicio: "8h", fim: "19h" },
      quarta: { inicio: "8h", fim: "19h" },
      quinta: { inicio: "8h", fim: "19h" },
      sexta: { inicio: "8h", fim: "19h" },
      sabado: { inicio: "8h", fim: "19h" },
      domingo: null
    },
    servicos: ["Banho e Tosa", "Rações", "Produtos veterinários", "Sementes e fertilizantes", "Insumos agrícolas", "Entregas"],
    endereco: "Estância Quintas da Alvorada Altiplano Leste - Paranoá, Brasília - DF | Estação Marina da Rocha: Rua 5, lote 1, Forquilha Encravada",
    redesSociais: {
      instagram: "https://www.instagram.com/agropecuariaflordocerrado/"
    },
    imagem: "/images/lojistas/flor.png",
    logo: "/images/lojistas/agropecuaria.png",
    avaliacao: 5.0,
    numeroAvaliacoes: 4,
    telefone: "(61) 99848-9245",
    whatsapp: "61998489245",
    andar: "Térreo",
    preco: "R$ 10 - R$ 200",
    aberto: true,
    promocao: {
      titulo: "Banho & Tosa",
      descricao: "A melhor do Altiplano Leste, agora no Estação Marina da Rocha"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito", "Banho e Tosa"],
    especialidades: ["Banho e Tosa", "Produtos Veterinários", "Rações Premium", "Sementes e Fertilizantes", "Insumos Agrícolas", "Pet Shop", "Atendimento Especializado"],
    tags: ["Agropecuária", "Pet Shop", "Banho e Tosa", "Veterinário", "Rações", "Insumos"]
  },

  contem: {
    id: "contem",
    nome: "Contem Bar",
    tipo: "Bar e Restaurante",
    descricao: "Bar e restaurante com petiscos, cerveja gelada e música.",
    horarioFuncionamento: {
      segunda: { inicio: "17h", fim: "23h" },
      terca: { inicio: "17h", fim: "23h" },
      quarta: { inicio: "17h", fim: "23h" },
      quinta: { inicio: "17h", fim: "23h" },
      sexta: { inicio: "17h", fim: "23h" },
      sabado: { inicio: "11h", fim: "23h" },
      domingo: null
    },
    servicos: ["Bar", "Restaurante", "Karaokê", "Espetáculos ao vivo", "Esplanada", "Petiscos", "Distribuidora de bebidas"],
    endereco: "Altiplano Leste - Paranoá, Brasília - DF, 71675-205",
    redesSociais: {
      instagram: "https://www.instagram.com/contemdf/"
    },
    imagem: "/images/lojistas/contem.webp",
    logo: "/images/lojistas/contem.webp",
    avaliacao: 4.8,
    numeroAvaliacoes: 36,
    telefone: "(61) 98139-4774",
    whatsapp: "61981394774",
    andar: "Térreo",
    preco: "R$ 40 - R$ 60",
    aberto: true,
    promocao: {
      titulo: "Container Experience",
      descricao: "Cerveja gelada, comidas incríveis e música boa"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Esplanada", "Wi-Fi Gratuito", "Karaokê", "Espetáculos ao vivo"],
    especialidades: ["Cervejas Geladas", "Petiscos", "Karaokê", "Espetáculos ao Vivo", "Ambiente Familiar", "Distribuidora de Bebidas", "Música ao Vivo"],
    tags: ["Bar", "Restaurante", "Karaokê", "Cerveja", "Petiscos", "Música"]
  },

  donjeff: {
    id: "donjeff",
    nome: "DonJeff Barbearia",
    tipo: "Barbearia",
    descricao: "Barbearia masculina com cortes de cabelo e barba.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "21h" },
      terca: { inicio: "9h", fim: "21h" },
      quarta: { inicio: "9h", fim: "21h" },
      quinta: { inicio: "9h", fim: "21h" },
      sexta: { inicio: "9h", fim: "21h" },
      sabado: { inicio: "9h", fim: "19h" },
      domingo: { inicio: "9h", fim: "13h" }
    },
    servicos: ["Corte de cabelo", "Corte de barba", "Kids e Teens", "Barbearia completa"],
    endereco: "Rua 5, chácara 01 - loja 104 - Altiplano Leste - Jardim Botânico, Brasília - DF, 71680-900",
    redesSociais: {
      instagram: "https://www.instagram.com/donjeffbarbearia/"
    },
    imagem: "/images/lojistas/donjeff.png",
    logo: "/images/lojistas/donjeff.png",
    avaliacao: 4.9,
    numeroAvaliacoes: 196,
    telefone: "(61) 99998-7654",
    whatsapp: "61999987654",
    andar: "Térreo",
    preco: "R$ 30 - R$ 80",
    aberto: true,
    promocao: {
      titulo: "Experiência Única",
      descricao: "Ambientes agradáveis e estilosos para uma experiência além do corte"
    },
    comodidades: ["Wi-Fi Gratuito", "Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Ambiente Estiloso"],
    especialidades: ["Corte de Cabelo", "Corte de Barba", "Kids e Teens", "Barbeiros Qualificados", "Ambiente Estiloso", "Experiência Única", "Decoração Nota 10"],
    tags: ["Barbearia", "Corte", "Estilo", "Masculino", "Kids"]
  },

  imperio: {
    id: "imperio",
    nome: "Império",
    tipo: "Material de construção",
    descricao: "Loja de materiais de construção do básico ao acabamento.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "19h" },
      terca: { inicio: "9h", fim: "19h" },
      quarta: { inicio: "9h", fim: "19h" },
      quinta: { inicio: "9h", fim: "19h" },
      sexta: { inicio: "9h", fim: "19h" },
      sabado: { inicio: "9h", fim: "19h" },
      domingo: null
    },
    servicos: ["Vendas presenciais", "Moda masculina", "Moda feminina", "Venda online"],
    endereco: "Av. Altiplano Leste - Marina da Rocha",
    redesSociais: {
      instagram: "https://www.instagram.com/imperioeletricahidraulica/"
    },
    imagem: "/images/lojistas/imperio.png",
    logo: "/images/lojistas/imperio.png",
    avaliacao: 4.5,
    numeroAvaliacoes: 89,
    telefone: "(61) 99691-9006",
    whatsapp: "61996919006",
    andar: "1º Andar",
    preco: "R$ 50 - R$ 250",
    aberto: true,
    promocao: {
      titulo: "Coleção Nova",
      descricao: "Até 25% de desconto em peças selecionadas"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Provador"],
    especialidades: ["Moda Masculina", "Moda Feminina", "Peças Modernas", "Consultoria de Estilo", "Atendimento Personalizado"],
    tags: ["Moda", "Masculino", "Feminino", "Moderno"]
  },

  logoCostura: {
    id: "logoCostura",
    nome: "Deusa Ateliê de Costura",
    tipo: "Ateliê de costura",
    descricao: "Consertos, ajustes e reparo em roupas.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "18h" },
      terca: { inicio: "9h", fim: "18h" },
      quarta: { inicio: "9h", fim: "18h" },
      quinta: { inicio: "9h", fim: "18h" },
      sexta: { inicio: "9h", fim: "18h" },
      sabado: { inicio: "9h", fim: "18h" },
      domingo: null
    },
    servicos: ["Consertos", "Ajustes", "Confeccção sob medida", "Alterações"],
    endereco: "Av. Altiplano Leste - Marina da Rocha",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/costura.jpeg",
    logo: "/images/lojistas/costura.jpeg",
    avaliacao: 4.8,
    numeroAvaliacoes: 112,
    telefone: "(61) 99691-9007",
    whatsapp: "61996919007",
    andar: "1º Andar",
    preco: "R$ 15 - R$ 200",
    aberto: true,
    promocao: {
      titulo: "Conserto Rápido",
      descricao: "Consertos simples a partir de R$ 15"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito"],
    especialidades: ["Consertos", "Ajustes", "Confeccção Sob Medida", "Alterações", "Qualidade"],
    tags: ["Costura", "Consertos", "Sob Medida", "Ajustes"]
  },

  marceloEeH: {
    id: "marceloEeH",
    nome: "Marcelo E&H",
    tipo: "Manutenção e Reparos",
    descricao: "Assistência técnica somente em eletroeletrônicos.",
    horarioFuncionamento: {
      segunda: { inicio: "7h30", fim: "18h" },
      terca: { inicio: "7h30", fim: "18h" },
      quarta: { inicio: "7h30", fim: "18h" },
      quinta: { inicio: "7h30", fim: "18h" },
      sexta: { inicio: "7h30", fim: "18h" },
      sabado: { inicio: "7h30", fim: "14h" },
      domingo: null
    },
    servicos: ["Materiais elétricos", "Materiais hidráulicos", "Materiais de construção", "Vendas presenciais", "Atendimento especializado"],
    endereco: "Sítio Forquilha, Rua 5, Setor Altiplano Leste, chácara 14 loja 103, Brasília - DF, 71698-900",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/assistencia.png",
    logo: "/images/lojistas/marceloEeH.png",
    avaliacao: 4.6,
    numeroAvaliacoes: 67,
    telefone: "(61) 99965-7326",
    whatsapp: "61999657326",
    andar: "Térreo",
    preco: "R$ 10 - R$ 500",
    aberto: true,
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito"],
    especialidades: ["Materiais Elétricos", "Materiais Hidráulicos", "Materiais de Construção", "Atendimento Especializado", "Produtos de Qualidade"],
    tags: ["Construção", "Elétrica", "Hidráulica", "Materiais"]
  },

  mercadoLivre: {
    id: "mercadoLivre",
    nome: "Hobby Verde - Agência Mercado Livre",
    tipo: "Loja para jardim e plantas / Agência de envios",
    descricao: "Insumos para plantas e agência oficial do Mercado Livre.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "18h" },
      terca: { inicio: "9h", fim: "18h" },
      quarta: { inicio: "9h", fim: "18h" },
      quinta: { inicio: "9h", fim: "18h" },
      sexta: { inicio: "9h", fim: "18h" },
      sabado: { inicio: "9h", fim: "18h" },
      domingo: null
    },
    servicos: ["Insumos para plantas", "Adubos químicos e orgânicos", "Sementes", "Vasos e acessórios", "Envio de produtos", "Recebimento Mercado Livre", "Retirada de encomendas", "Suporte ao vendedor", "Envio para todo Brasil"],
    endereco: "Sítio Forquilha, Rua 05 Chácara 14 Estação Marina da Rocha, Jardim Botânico (Lago Sul) Altiplano Leste Loja 112, Brasília - DF, 71680-900",
    redesSociais: {
      instagram: "https://www.instagram.com/hobby.verde/"
    },
    imagem: "/images/lojistas/hobby.png",
    logo: "/images/lojistas/hobby.png",
    logoSecundario: "/images/lojistas/mercado-livre.png",
    avaliacao: 4.1,
    numeroAvaliacoes: 119,
    telefone: "(61) 3248-0176",
    whatsapp: "6132480176",
    andar: "Térreo",
    preco: "R$ 10 - R$ 200",
    aberto: true,
    promocao: {
      titulo: "Envio para Todo Brasil",
      descricao: "Tudo de que sua planta necessita com entrega em todo o país"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito", "Envio para todo Brasil"],
    especialidades: ["Insumos para Plantas", "Adubos Químicos e Orgânicos", "Sementes de Hortaliças", "Vasos e Acessórios", "Agência Mercado Livre", "Retirada de Encomendas", "Envio para Todo Brasil", "Corretivos de Solo"],
    tags: ["Jardim", "Plantas", "Insumos", "Mercado Livre", "Agência", "Envio"]
  },

  vivaMais: {
    id: "vivaMais",
    nome: "Estúdio Viva Mais",
    tipo: "Estúdio de Musculação e Pilates",
    descricao: "Musculação e pilates com acompanhamento profissional.",
    horarioFuncionamento: {
      segunda: { inicio: "6h", fim: "22h" },
      terca: { inicio: "6h", fim: "22h" },
      quarta: { inicio: "6h", fim: "22h" },
      quinta: { inicio: "6h", fim: "22h" },
      sexta: { inicio: "6h", fim: "22h" },
      sabado: { inicio: "8h", fim: "12h" },
      domingo: null
    },
    servicos: ["Musculação", "Pilates", "Aulas personalizadas", "Avaliação física", "Acompanhamento profissional", "Agendamento de horários"],
    endereco: "Estrada do Altiplano Leste - Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "https://www.instagram.com/studio_viva_mais_altiplano/"
    },
    imagem: "/images/lojistas/vivamais.jpeg",
    logo: "/images/lojistas/vivamais.jpeg",
    avaliacao: 4.8,
    numeroAvaliacoes: 234,
    telefone: "(61) 99691-9010",
    whatsapp: "61996919010",
    andar: "Térreo",
    preco: "R$ 299 - R$ 599",
    aberto: true,
    promocao: {
      titulo: "Aula Gratuita",
      descricao: "Faça sua aula experimental gratuita e conheça nosso método"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito", "Vestiários", "Acompanhamento Personalizado"],
    especialidades: ["Musculação Personalizada", "Pilates", "Acompanhamento Profissional", "Sem Superlotação", "Escala 3 para 1", "Avaliação Física", "Treinos Personalizados", "Fisioterapeutas"],
    tags: ["Academia", "Musculação", "Pilates", "Personal Trainer", "Fitness", "Saúde"]
  },

  espacoSena: {
    id: "espacoSena",
    nome: "Espaço Sena",
    tipo: "Academia / esportes",
    descricao: "Academia com musculação e treinos funcionais.",
    horarioFuncionamento: {
      segunda: { inicio: "6h", fim: "21h" },
      terca: { inicio: "6h", fim: "21h" },
      quarta: { inicio: "6h", fim: "21h" },
      quinta: { inicio: "6h", fim: "21h" },
      sexta: { inicio: "6h", fim: "21h" },
      sabado: { inicio: "8h", fim: "12h" },
      domingo: { inicio: "0h", fim: "23h" }
    },
    servicos: ["Musculação", "Treino funcional", "Avaliação física", "Acompanhamento profissional", "Planos personalizados"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/sena.jpeg",
    logo: "/images/lojistas/sena.jpeg",
    avaliacao: 4.8,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 120 - R$ 250",
    aberto: true,
    promocao: {
      titulo: "Matrícula gratuita",
      descricao: "Planos especiais para novos alunos"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Vestiários"],
    especialidades: ["Musculação", "Treino Funcional", "Performance", "Condicionamento Físico", "Acompanhamento Profissional"],
    tags: ["Academia", "Esportes", "Musculação", "Funcional", "Fitness"]
  },

  wagnervieira: {
    id: "wagnervieira",
    nome: "Wagner Vieira BBQ",
    tipo: "Restaurante",
    descricao: "Restaurante barbecue com costelas smoked e hamburgueres.",
    horarioFuncionamento: {
      segunda: { inicio: "8h", fim: "18h" },
      terca: { inicio: "8h", fim: "18h" },
      quarta: { inicio: "8h", fim: "18h" },
      quinta: { inicio: "8h", fim: "18h" },
      sexta: { inicio: "8h", fim: "18h" },
      sabado: null,
      domingo: null
    },
    servicos: ["Barbecue", "Costelas smoked", "Hamburgueres artesanais"],
    endereco: "Av. Altiplano Leste - Marina da Rocha",
    redesSociais: {
      instagram: "https://www.instagram.com/wagnervieirabbq/"
    },
    imagem: "/images/lojistas/wagner.png",
    logo: "/images/lojistas/wagnervieira.png",
    avaliacao: 4.7,
    numeroAvaliacoes: 95,
    telefone: "(61) 99691-9011",
    whatsapp: "61996919011",
    andar: "Térreo",
    preco: "R$ 50 - R$ 500",
    aberto: true,
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito"],
    especialidades: ["Costelas Smoked", "Hamburgueres Artesanais", "Barbecue", "Carnes Defumadas"],
    tags: ["Restaurante", "Barbecue", "Smoked", "Hamburguer", "Costelas"]
  },

  santa: {
    id: "santa",
    nome: "Santa",
    tipo: "Distribuidora de Bebidas",
    descricao: "Distribuidora de bebidas no atacado e varejo.",
    horarioFuncionamento: {
      segunda: { inicio: "8h", fim: "20h" },
      terca: { inicio: "8h", fim: "20h" },
      quarta: { inicio: "8h", fim: "20h" },
      quinta: { inicio: "8h", fim: "20h" },
      sexta: { inicio: "8h", fim: "20h" },
      sabado: { inicio: "8h", fim: "20h" },
      domingo: { inicio: "9h", fim: "18h" }
    },
    servicos: ["Venda de bebidas", "Atacado e varejo", "Entrega", "Atendimento especializado", "Grandes marcas"],
    endereco: "Estrada do Altiplano Leste - Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "",
      facebook: ""
    },
    imagem: "/images/lojistas/santa.png",
    logo: "/images/lojistas/santa.jpg",
    avaliacao: 4.6,
    numeroAvaliacoes: 128,
    telefone: "(61) 99999-8888",
    whatsapp: "61999998888",
    andar: "Térreo",
    preco: "R$ 5 - R$ 200",
    aberto: true,
    promocao: {
      titulo: "Ofertas Especiais",
      descricao: "Os melhores preços em cervejas e bebidas da região"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito", "Entrega"],
    especialidades: ["Cervejas", "Refrigerantes", "Sucos", "Água", "Bebidas Alcoólicas", "Atacado e Varejo", "Grandes Marcas", "Preços Competitivos"],
    tags: ["Bebidas", "Distribuidora", "Cerveja", "Atacado", "Varejo"]
  },

  geltec: {
    id: "geltec",
    nome: "Geltec Assistência Técnica",
    tipo: "Assistência Técnica",
    descricao: "Assistência técnica de celulares e smartphones.",
    horarioFuncionamento: {
      segunda: { inicio: "8h", fim: "18h" },
      terca: { inicio: "8h", fim: "18h" },
      quarta: { inicio: "8h", fim: "18h" },
      quinta: { inicio: "8h", fim: "18h" },
      sexta: { inicio: "8h", fim: "18h" },
      sabado: { inicio: "8h", fim: "12h" },
      domingo: null
    },
    servicos: ["Reparo de celulares", "Troca de tela", "Troca de bateria", "Manutenção de smartphones", "Atendimento especializado"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "",
      facebook: ""
    },
    imagem: "/images/lojistas/geltec.webp",
    logo: "/images/lojistas/geltec.jpeg",
    avaliacao: 4.5,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 50 - R$ 500",
    aberto: true,
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito"],
    especialidades: ["Reparo de Celulares", "Troca de Tela", "Troca de Bateria", "Manutenção de Smartphones", "Peças Originais"],
    tags: ["Assistência Técnica", "Celulares", "Smartphones", "Reparo"]
  },

  roccia: {
    id: "roccia",
    nome: "Zé Roccia",
    tipo: "Restaurante",
    descricao: "Pizzaria com massas artesanais e ambiente aconchegante.",
    horarioFuncionamento: {
      segunda: { inicio: "18h", fim: "23h" },
      terca: { inicio: "18h", fim: "23h" },
      quarta: { inicio: "18h", fim: "23h" },
      quinta: { inicio: "18h", fim: "23h" },
      sexta: { inicio: "18h", fim: "23h59" },
      sabado: { inicio: "18h", fim: "23h59" },
      domingo: { inicio: "18h", fim: "22h" }
    },
    servicos: ["Pizzas artesanais", "Massas", "Delivery", "Reservas", "Ambiente climatizado"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "",
      facebook: ""
    },
    imagem: "/images/lojistas/roccia.jpeg",
    logo: "/images/lojistas/roccia.jpeg",
    avaliacao: 4.8,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 60 - R$ 120",
    aberto: true,
    promocao: {
      titulo: "Pizzas Artesanais",
      descricao: "Ingredientes selecionados e receitas autênticas"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Delivery", "Reservas"],
    especialidades: ["Pizzas Artesanais", "Massas", "Alto Padrão", "Ingredientes Selecionados", "Ambiente Sofisticado"],
    tags: ["Pizzaria", "Alto Padrão", "Restaurante", "Massas"]
  },

  viachiari: {
    id: "viachiari",
    nome: "Via Chiari",
    tipo: "Loja de Roupas",
    descricao: "Loja de roupas com peças selecionadas.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "19h" },
      terca: { inicio: "9h", fim: "19h" },
      quarta: { inicio: "9h", fim: "19h" },
      quinta: { inicio: "9h", fim: "19h" },
      sexta: { inicio: "9h", fim: "19h" },
      sabado: { inicio: "9h", fim: "19h" },
      domingo: null
    },
    servicos: ["Moda feminina", "Moda masculina", "Consultoria de estilo", "Atendimento personalizado"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "",
      facebook: ""
    },
    imagem: "/images/lojistas/chiari.jpeg",
    logo: "/images/lojistas/viachiari.png",
    avaliacao: 4.9,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 200 - R$ 2000",
    aberto: true,
    promocao: {
      titulo: "Coleção Exclusiva",
      descricao: "Moda de alto padrão com peças selecionadas"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Provador"],
    especialidades: ["Moda Feminina", "Moda Masculina", "Alto Padrão", "Consultoria de Estilo", "Peças Exclusivas"],
    tags: ["Moda", "Alto Padrão", "Roupas", "Elegância"]
  },

  fornodelucca: {
    id: "fornodelucca",
    nome: "Forno do Lucca",
    tipo: "Restaurante",
    descricao: "Restaurante self service no almoço e, à noite, hamburgueria e pizzaria com entregas.",
    horarioFuncionamento: {
      segunda: { inicio: "11h", fim: "22h30" },
      terca: { inicio: "11h", fim: "22h30" },
      quarta: { inicio: "11h", fim: "22h30" },
      quinta: { inicio: "11h", fim: "22h30" },
      sexta: { inicio: "11h", fim: "22h30" },
      sabado: { inicio: "11h", fim: "22h30" },
      domingo: { inicio: "18h", fim: "22h30" }
    },
    servicos: ["Self service", "Pizzas", "Hamburgueres", "Delivery"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: "",
      facebook: ""
    },
    imagem: "/images/lojistas/forno.png",
    logo: "/images/lojistas/forno.png",
    avaliacao: 4.8,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 50 - R$ 120",
    aberto: true,
    promocao: {
      titulo: "Massas Artesanais",
      descricao: "Culinária italiana autêntica com ingredientes selecionados"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Delivery", "Reservas"],
    especialidades: ["Massas Artesanais", "Pizzas Tradicionais", "Culinária Italiana", "Ambiente Familiar", "Ingredientes Selecionados"],
    tags: ["Restaurante", "Italiano", "Pizza", "Massa", "Culinária Italiana"]
  },

  takosushi: {
    id: "takosushi",
    nome: "Tako Sushi",
    tipo: "Restaurante japonês",
    descricao: "Restaurante japonês com sushis, sashimis e pratos quentes.",
    horarioFuncionamento: {
      segunda: { inicio: "12h", fim: "22h" },
      terca: { inicio: "12h", fim: "22h" },
      quarta: { inicio: "12h", fim: "22h" },
      quinta: { inicio: "12h", fim: "22h" },
      sexta: { inicio: "12h", fim: "22h" },
      sabado: { inicio: "12h", fim: "22h" },
      domingo: { inicio: "12h", fim: "22h" }
    },
    servicos: ["Sushi", "Sashimi", "Combinados", "Pratos quentes", "Delivery"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/tako.png",
    logo: "/images/lojistas/tako.png",
    avaliacao: 4.7,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 35 - R$ 120",
    aberto: true,
    promocao: {
      titulo: "Combinado da casa",
      descricao: "Seleção especial de sushis e sashimis"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito", "Delivery"],
    especialidades: ["Sushi", "Sashimi", "Combinados", "Temakis", "Culinária Japonesa"],
    tags: ["Restaurante", "Japonês", "Sushi", "Sashimi", "Temaki"]
  },

  vidaLeve: {
    id: "vidaLeve",
    nome: "Vida Leve",
    tipo: "Produtos naturais e fitness",
    descricao: "Produtos naturais, fitness e saudáveis.",
    horarioFuncionamento: {
      segunda: { inicio: "9h", fim: "19h" },
      terca: { inicio: "9h", fim: "19h" },
      quarta: { inicio: "9h", fim: "19h" },
      quinta: { inicio: "9h", fim: "19h" },
      sexta: { inicio: "9h", fim: "19h" },
      sabado: { inicio: "9h", fim: "19h" },
      domingo: { inicio: "9h", fim: "14h" }
    },
    servicos: ["Produtos naturais", "Suplementos", "Snacks saudáveis", "Chás e ervas", "Acessórios fitness"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/vida-leve.png",
    logo: "/images/lojistas/vida-leve.png",
    avaliacao: 4.7,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 10 - R$ 200",
    aberto: true,
    promocao: {
      titulo: "Combos saudáveis",
      descricao: "Seleções especiais de produtos naturais"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito"],
    especialidades: ["Produtos Naturais", "Fitness", "Saudáveis", "Suplementos", "Snacks Funcionais"],
    tags: ["Produtos Naturais", "Fitness", "Saudáveis", "Bem-estar", "Suplementos"]
  },

  padaria: {
    id: "padaria",
    nome: "Artesanarium - Oficina de Pães",
    tipo: "Padaria de Fermentação Natural",
    descricao: "Pães, doces, salgados e café.",
    horarioFuncionamento: {
      segunda: { inicio: "6h", fim: "20h" },
      terca: { inicio: "6h", fim: "20h" },
      quarta: { inicio: "6h", fim: "20h" },
      quinta: { inicio: "6h", fim: "20h" },
      sexta: { inicio: "6h", fim: "20h" },
      sabado: { inicio: "6h", fim: "20h" },
      domingo: { inicio: "6h", fim: "20h" }
    },
    servicos: ["Pães artesanais", "Doces", "Salgados", "Café", "Lanches"],
    endereco: "Estação Marina da Rocha - Paranoá, Brasília - DF",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/padaria.webp",
    logo: "/images/lojistas/padaria.webp",
    avaliacao: 4.7,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "R$ 5 - R$ 40",
    aberto: true,
    promocao: {
      titulo: "Pão do dia",
      descricao: "Pães fresquinhos todos os dias"
    },
    comodidades: ["Ar Condicionado", "Acessível", "Aceita Cartão", "Wi-Fi Gratuito"],
    especialidades: ["Pães Artesanais", "Doces", "Salgados", "Café", "Lanches"],
    tags: ["Padaria", "Pães", "Doces", "Salgados", "Café"]
  },

  igrejaPresbiteriana: {
    id: "igrejaPresbiteriana",
    nome: "Igreja Presbiteriana no Altiplano Leste",
    tipo: "Igreja",
    descricao: "Aconselhamento e discipulado com agendamento, reuniões semanais e cultos aos domingos.",
    horarioFuncionamento: {
      segunda: null,
      terca: { inicio: "9h", fim: "18h" },
      quarta: { inicio: "9h", fim: "18h" },
      quinta: { inicio: "9h", fim: "21h" },
      sexta: { inicio: "9h", fim: "18h" },
      sabado: { inicio: "9h", fim: "18h" },
      domingo: { inicio: "9h", fim: "11h15" }
    },
    servicos: [
      "Aconselhamento bíblico (com agendamento)",
      "Discipulado (com agendamento)",
      "Reunião de oração (quinta 19h30)",
      "Reunião departamental (sábado)",
      "Culto matutino e EBD (domingo 9h–11h15)",
      "Culto solene (domingo 19h)"
    ],
    endereco: "Estação Marina da Rocha - Altiplano Leste, Brasília - DF",
    redesSociais: {
      instagram: ""
    },
    imagem: "/images/lojistas/igreja 01.jpeg",
    logo: "",
    avaliacao: 5.0,
    numeroAvaliacoes: 0,
    telefone: "(61) 00000-0000",
    whatsapp: "61000000000",
    andar: "Térreo",
    preco: "N/A",
    aberto: true,
    promocao: null,
    comodidades: ["Acessível", "Aceita Cartão", "Estacionamento", "Wi-Fi Gratuito"],
    especialidades: ["Aconselhamento", "Discipulado", "Reuniões", "Cultos"],
    tags: ["Igreja", "Comunidade", "Fé", "Altiplano Leste"]
  }
};

// Contadores por tipo
export const contadores = {
  restaurante: 2,
  sorveteriaEAcai: 1,
  agropecuaria: 1,
  lojaDeVariedades: 1,
  lojaDeRoupas: 1,
  atelieDeCostura: 1,
  servicos: 2,
  agenciaDeEnvios: 1,
  farmacia: 1,
  saude: 2
};

// Função para obter todas as empresas como array
export const obterTodasEmpresas = () => {
  return Object.values(empresas).sort((a, b) =>
    a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
  );
};

// Função para obter empresa por ID
export const obterEmpresaPorId = (id) => {
  return empresas[id];
};

// Função para filtrar empresas por tipo
export const filtrarEmpresasPorTipo = (tipo) => {
  return Object.values(empresas).filter(empresa => empresa.tipo === tipo);
};

// Função para buscar empresas por nome
export const buscarEmpresasPorNome = (termo) => {
  const termoLower = termo.toLowerCase();
  return Object.values(empresas).filter(empresa => 
    empresa.nome.toLowerCase().includes(termoLower) ||
    empresa.descricao.toLowerCase().includes(termoLower) ||
    empresa.servicos.some(servico => servico.toLowerCase().includes(termoLower))
  );
};

// Função para obter contagens de categorias
export const obterContagensCategorias = () => {
  const contagens = {
    'alimentacao': 0,
    'moda': 0,
    'beleza': 0,
    'servicos': 0,
    'saude': 0,
    'tecnologia': 0,
    'casa': 0,
    'educacao': 0
  };

  Object.values(empresas).forEach(empresa => {
    switch(empresa.tipo) {
      case 'Restaurante':
      case 'Sorveteria e açaí':
        contagens.alimentacao++;
        break;
      case 'Loja de roupas':
      case 'Ateliê de costura':
        contagens.moda++;
        break;
      case 'Salão de beleza':
        contagens.beleza++;
        break;
      case 'Loja para jardim e plantas':
        contagens.casa++;
        break;
      case 'Agropecuária':
      case 'Agropecuária, pet e tosa':
      case 'Serviços':
      case 'Agência de envios':
        contagens.servicos++;
        break;
      case 'Farmácia':
      case 'Estúdio de Musculação e Pilates':
      case 'Academia / esportes':
        contagens.saude++;
        break;
      default:
        // Para tipos não mapeados, adicionar em serviços
        contagens.servicos++;
        break;
    }
  });

  return contagens;
};

// Função para obter contagens de faixas de preço
export const obterContagensFaixasPreco = () => {
  const contagens = {
    'economico': 0,
    'medio': 0,
    'premium': 0,
    'luxo': 0
  };

  Object.values(empresas).forEach(empresa => {
    const preco = empresa.preco;
    if (typeof preco === 'string' && preco.includes('R$')) {
      // Extrair valores numéricos do preço
      const valores = preco.match(/\d+/g);
      if (valores && valores.length >= 2) {
        const valorMin = parseInt(valores[0]);
        const valorMax = parseInt(valores[1]);
        const valorMedio = (valorMin + valorMax) / 2;
        
        if (valorMedio <= 50) contagens.economico++;
        else if (valorMedio <= 150) contagens.medio++;
        else if (valorMedio <= 300) contagens.premium++;
        else contagens.luxo++;
      }
    }
  });

  return contagens;
};

// Função para obter contagens de serviços
export const obterContagensServicos = () => {
  const servicosMap = {
    'delivery': 'Delivery',
    'cartao': 'Aceita Cartão',
    'pix': 'PIX',
    'estacionamento': 'Estacionamento',
    'wifi': 'Wi-Fi Gratuito',
    'acessibilidade': 'Acessível'
  };

  const contagens = {};
  Object.keys(servicosMap).forEach(servicoId => {
    const servicoNome = servicosMap[servicoId];
    contagens[servicoId] = Object.values(empresas).filter(empresa => 
      empresa.comodidades && empresa.comodidades.some(comodidade => 
        comodidade.toLowerCase().includes(servicoNome.toLowerCase())
      )
    ).length;
  });

  return contagens;
};

// Função para obter contagens especiais
export const obterContagensEspeciais = () => {
  const empresasArray = Object.values(empresas);
  
  return {
    comPromocoes: empresasArray.filter(empresa => empresa.promocao).length,
    abertas: empresasArray.filter(empresa => empresa.aberto).length
  };
};

// Função para obter tipos únicos de lojas com suas contagens
export const obterTiposLojas = () => {
  const tiposMap = {};
  
  Object.values(empresas).forEach(empresa => {
    const tipo = empresa.tipo;
    if (tipo) {
      if (!tiposMap[tipo]) {
        tiposMap[tipo] = 0;
      }
      tiposMap[tipo]++;
    }
  });
  
  // Converter para array e ordenar por nome
  return Object.entries(tiposMap)
    .map(([tipo, count]) => ({
      tipo,
      count
    }))
    .sort((a, b) => a.tipo.localeCompare(b.tipo));
};
